(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rootelier-v2-showroom-card"] && !Shopify.designMode) return;
  try {
    // Mui ten + cham vi tri cho slider anh tren the showroom
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sr-step]');
    if (!btn) return;
    const track = btn.parentElement.querySelector('[data-sr-track]');
    track.scrollBy({ left: track.clientWidth * Number(btn.dataset.srStep), behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => {
    const track = e.target;
    if (!(track instanceof Element) || !track.matches('[data-sr-track]')) return;
    const i = Math.round(track.scrollLeft / track.clientWidth);
    track.parentElement.querySelectorAll('.r-sr__dots i').forEach((d, k) => d.classList.toggle('is-on', k === i));
  }, true);
  } catch(e) { console.error(e); }
})();

})();
